import { Flags } from './flags';
import isValidPhoneNumber, { AsYouType } from 'libphonenumber-js';
import { I18n } from './i18n';

function debounce<T extends (...args: never[]) => void>(fn: T, wait: number) {
  let timer: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), wait);
  };
}

function sendMsg(where: string, via: string) {
  setError('');

  const number = where.replace(/[^0-9]/g, '');

  if (!isValidPhoneNumber(where) || number.length <= 8) {
    setError(I18n.getCurrentTranslation().errorInvalidNumber);
    return;
  }

  const url = `https://${via}.whatsapp.com/send?phone=${number}`

  window.open(url, '_blank').focus();
}

function setError(text: string) {
  const el = document.getElementById('error');
  el.textContent = text;
  if (text.length > 0) {
    el.style.display = 'block';
  } else {
    el.style.display = 'none';
  }
}

window.onload = () => {
  // Initialize internationalization
  I18n.initialize();

  const input = document.getElementById('number') as HTMLInputElement;

  fetch('https://geoipme.dev/json')
    .then(response => response.json())
    .then(data => {
      const code = data['country_code'];
      Flags.setCurrentFlag(code);
      Flags.setCurrentPrefix(code);
      input.addEventListener('input', () => {
        let v = input.value.trim();
        if (v[0] != '+' && v.length != 0) {
          v = '+' + v;
        }
        input.value = new AsYouType(code).input(v);
      });
    });

  const isMobile = /Mobi/i.test(window.navigator.userAgent)

  const send_app = document.getElementById('send_app');
  const send_web = document.getElementById('send_web');

  send_app.onclick = () => { sendMsg(input.value, 'api') };

  if (isMobile) {
    send_web.style.display = 'none';
  } else {
    send_web.onclick = () => { sendMsg(input.value, 'web') };
  }

  input.addEventListener('input', debounce(() => { Flags.guessCountryCode(input.value) }, 600));
};